import React from "react";
import { AppBar, Box, Typography } from "@mui/material";

const Header = () => {
  return (
    <AppBar position="static">
      <Box p={2}>
        <Typography variant="h1" color="inherit" component="div">
          Accessible Jobs
        </Typography>
      </Box>
    </AppBar>
  );
};

export default Header;
